import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "control" }
const _hoisted_4 = ["name", "id", "value", "required"]

import { computed, ref, watch } from "vue";

interface Props {
  formClass: string;
  attribute: string;
  label: string;
  modelValue: string;
  required?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'text-area',
  props: {
    formClass: {},
    attribute: {},
    label: {},
    modelValue: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const dataValue = ref(props.modelValue);

// Handle input events with proper typing
function handleInput(event: Event) {
  const target = event.target as HTMLTextAreaElement;
  emit("update:modelValue", target.value);
}

watch(
  () => props.modelValue,
  (newVal) => {
    dataValue.value = newVal;
  }
);

const textAreaName = computed(() => `${props.formClass}[${props.attribute}]`);
const textAreaId = computed(() => `${props.formClass}_${props.attribute}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: "label",
      for: textAreaId.value
    }, _toDisplayString(__props.label), 9, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("textarea", {
        class: "textarea",
        name: textAreaName.value,
        id: textAreaId.value,
        value: dataValue.value,
        onInput: handleInput,
        required: __props.required
      }, null, 40, _hoisted_4)
    ])
  ]))
}
}

})